// extracted by mini-css-extract-plugin
export default {"container":"Benefits_container__2C0l1","bkg":"Benefits_bkg__5g4vX","bkg_2":"Benefits_bkg_2__9fLLs","spacing":"Benefits_spacing__aod+O","card":"Benefits_card__HX2j7"};